import React from "react";

const ValidationSkeleton = () => {
  return (
    <div className="w-100  bg-gray-100 d-flex flex-column align-items-center justify-content-center py-5 rounded-3" style={{ height: "532px" }}>
      <div className="text-center mb-4">
        <div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
          <span className="visually-hidden">Validando...</span>
        </div>
        <h5 className="text-primary mb-2">Validando QR...</h5>
        <p className="text-muted mb-0">Procesando código, por favor espera</p>
      </div>
      
      
      
      
      <div className="w-75 mt-4">
        <div className="progress" style={{ height: "8px" }}>
          <div 
            className="progress-bar progress-bar-striped progress-bar-animated" 
            role="progressbar" 
            style={{ width: "100%" }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ValidationSkeleton; 